import React, { useState } from "react";
import Utils from "Utils/utils";
import { toasterState } from "Components/common/toaster";
import SearchIcon from "Assets/svg/search.svg";

const TranscriptTab = ({ call = {}, transcriptLines = [], loading = false, generating = false, onGenerate = () => {} }) => {
  const { recordingUrl = "" } = call;

  const [search, setSearch] = useState("");
  const [copied, setCopied] = useState(false);

  const handleGenerate = () => onGenerate();

  const handleCopy = () => {
    const text = transcriptLines
      .map(line => `[${line.time}] ${line.name}: ${line.text}`)
      .join("\n");
    Utils.copyToClipboard(text);
    toasterState.setToastMsg("Transcript copied", "success");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const filteredLines = search
    ? transcriptLines.filter(line =>
      line.text.toLowerCase().includes(search.toLowerCase())
    )
    : transcriptLines;

  const highlightText = (text = "") => {
    if (!search) return text;
    const parts = text.split(new RegExp(`(${search})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <mark key={i} className="transcriptLineHighlight">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };

  if (loading) {
    return (
      <div className="transcriptTabGenerating">
        <div className="transcriptTabGeneratingIcon">
          <i className="material-icons transcriptTabSpinIcon">refresh</i>
        </div>
        <p className="transcriptTabGeneratingTitle">Loading transcript...</p>
      </div>
    );
  }

  if (!transcriptLines.length) {
    return (
      <div className="transcriptTabEmpty">
        <div className="transcriptTabEmptyIcon">
          <i className="material-icons-outlined">article</i>
        </div>
        <p className="transcriptTabEmptyTitle">No transcript yet</p>
        <p className="transcriptTabEmptyDesc">
          Generate a transcript to search and review the full conversation.
        </p>
        <button
          className={`transcriptTabGenerateBtn${generating ? " transcriptTabGenerateBtnLoading" : ""}${!recordingUrl ? " transcriptTabGenerateBtnDisabled" : ""}`}
          onClick={handleGenerate}
          disabled={generating || !recordingUrl}
        >
          {generating ? (
            <>
              <i className="material-icons transcriptTabSpinIcon">refresh</i>
              Generating...
            </>
          ) : (
            <>
              <img src={SearchIcon} alt="" className="transcriptTabGenerateBtnIcon" />
              Generate transcript
            </>
          )}
        </button>
        {!recordingUrl && (
          <p className="transcriptTabNoRecordingMsg">
            There is no call recording available to generate transcript
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="transcriptTab">
      <div className="transcriptTabToolbar">
        <div className="transcriptTabSearchBox">
          <i className="material-icons-outlined transcriptTabSearchIcon">search</i>
          <input
            className="transcriptTabSearchInput"
            placeholder="Search transcript..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          {search && (
            <span className="transcriptTabMatchCount">
              {filteredLines.length} match{filteredLines.length !== 1 ? "es" : ""}
            </span>
          )}
        </div>
        <button
          className={`transcriptTabCopyBtn${copied ? " transcriptTabCopyBtnCopied" : ""}`}
          onClick={handleCopy}
        >
          <i className="material-icons-outlined">
            {copied ? "check" : "content_copy"}
          </i>
          {copied ? "Copied" : "Copy"}
        </button>
      </div>

      <div className="transcriptTabLegend">
        <div className="transcriptTabLegendItem">
          <div className="transcriptTabAvatar transcriptTabAvatarRep">C</div>
          <span>Caller</span>
        </div>
        <div className="transcriptTabLegendItem">
          <div className="transcriptTabAvatar transcriptTabAvatarProspect">P</div>
          <span>Prospect</span>
        </div>
        <span className="transcriptTabLineCount">
          {transcriptLines.length} lines
        </span>
      </div>

      <div className="transcriptTabLines">
        {filteredLines.map((line, i) => {
          const isRep = line.s === "rep";
          return (
            <div
              key={i}
              className={`transcriptLine${isRep ? " transcriptLineRep" : " transcriptLineProspect"}`}
            >
              <div className="transcriptLineAvatarCol">
                <div className={`transcriptLineAvatar${isRep ? " transcriptLineAvatarRep" : " transcriptLineAvatarProspect"}`}>
                  {(line.name || "").split(" ").map(w => w[0]).join("").slice(0, 2)}
                </div>
                <span className="transcriptLineTime">{line.time}</span>
              </div>
              <div className="transcriptLineContent">
                <span className="transcriptLineText">{highlightText(line.text)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TranscriptTab;
